export const features = [
  // ========================= //
  // SCHEDULE KPI REPORTS
  // ========================= //
  {
    icon: 'file-chart-line',
    name: 'Scheduled KPI Reports',
    summary: `Get a summary of your most important KPIs emailed to you daily, weekly, or monthly.`,
    title: 'Get the Data You Need in the Format You Want It',
    lead: 'Access a variety of reports from driving and vehicles usage times, to expense reports, to digests of automations triggered in a specified date range.',
    image: '/images/features/custom-reports.png',
    sections: [
      {
        heading: 'Schedule Reports for Delivery',
        body: 'Set reports to be sent to your email inbox at regular intervals: daily, weekly, or monthly for any period of time.'
      },
      {
        heading: 'Granular Data',
        body: `Get data fidelity down to the hour, minute, and second. Automatically split trip times that run over midnight into the days they belong.`
      }
    ]
  },

  // ========================= //
  // AUTOMATIC COMPLIANCE REPORTS
  // ========================= //
  {
    icon: 'clipboard-list-check',
    name: 'Automatic Compliance Reports',
    summary: `Stop wasting time compiling reports for RTMS. Pull everything once in the format you need.`,
    title: 'Get the Data You Need in the Format You Want It',
    lead: 'Access a variety of reports from driving and vehicles usage times, to expense reports, to digests of automations triggered in a specified date range.',
    image: '/images/features/custom-reports.png',
    sections: [
      {
        heading: 'Schedule Reports for Delivery',
        body: 'Set reports to be sent to your email inbox at regular intervals: daily, weekly, or monthly for any period of time.'
      },
      {
        heading: 'Granular Data',
        body: `Get data fidelity down to the hour, minute, and second. Automatically split trip times that run over midnight into the days they belong.`
      }
    ]
  },

  // ========================= //
  // EXCEPTION TRACKING
  // ========================= //
  {
    icon: 'exclamation-circle',
    name: 'Exception Tracking',
    summary: `Track exceptions with preset rules. Specify exception reasons and get insights via trend reports to drive efficiencies.`,
    title: 'Get the Data You Need in the Format You Want It',
    lead: 'Access a variety of reports from driving and vehicles usage times, to expense reports, to digests of automations triggered in a specified date range.',
    image: '/images/features/custom-reports.png',
    sections: [
      {
        heading: 'Schedule Reports for Delivery',
        body: 'Set reports to be sent to your email inbox at regular intervals: daily, weekly, or monthly for any period of time.'
      },
      {
        heading: 'Granular Data',
        body: `Get data fidelity down to the hour, minute, and second. Automatically split trip times that run over midnight into the days they belong.`
      }
    ]
  },

  // ========================= //
  // EXPENSE RECORDS
  // ========================= //
  {
    icon: 'receipt',
    name: 'Expense Records',
    summary: `Track your fleet's expenses and get detailed reports like cost-per-kilometre to see which vehicles or drivers cost the most money.`,
    title: 'Track Your Fleet Expenses and Gain Insight Into Cost Centres',
    lead: 'The simplest way to track all your fleet-related expenses, with detailed cost reporting and file storage - creating a digital paper trail for each vehicle.',
    image: '/images/features/expense-records.png',
    sections: [
      {
        heading: 'Record All Your Fleet’s Expenses in One Place',
        body: 'Maintain an easily auditable log of all your fleet’s expenses with just a single form: fuel, repairs, services, tyres, fines, tolls, insurance premiums and more!'
      },
      {
        heading: 'Go Paperless',
        body: `Store digital copies of absolutely anything you'd need to keep a record of: receipts, invoices, contracts, certificates, photographs, etc.`
      },
      {
        heading: 'Reports with Just One Click',
        body: 'Get a complete month-by-month overview of all your fleet’s expenses and cost-per-kilometre in a downloadable report from a single button.'
      }
    ]
  },
]